import { render, staticRenderFns } from "./FilterPerson.vue?vue&type=template&id=36190d24"
import script from "./FilterPerson.vue?vue&type=script&lang=js"
export * from "./FilterPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports